import React from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';

const ReportView = ({ report, show, onHide }) => {
  if (!report) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{report.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3">
          <div className="col-md-6">
            <img
              src={report.imageUrl}
              alt={report.title}
              className="img-fluid rounded"
            />
          </div>
          <div className="col-md-6">
            <h5>Detalhes</h5>
            <p><strong>Data:</strong> {report.date}</p>
            <p>
              <strong>Severidade:</strong> {' '}
              <Badge
                bg={
                  report.severity === 'Alta' ? 'danger' :
                    report.severity === 'Média' ? 'warning text-dark' : 'success'
                }
              >
                {report.severity}
              </Badge>
            </p>
          </div>
        </div>

        <div className="mb-3">
          <h5>Descrição</h5>
          <p className="text-muted">{report.description}</p>
        </div>

        <div>
          <h5>Ação Recomendada</h5>
          <p className="text-muted">{report.action}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportView;
